var classes = {"kohlerReveal":"RdhSv","kohlerRevealHidden":"D-kpJ","kohlerRevealVisible":"jPP9m"};

export { classes as default };
